import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'

import { UserAuthentication } from '@/components/auth/UserAuthentication'
import { ConceptImage } from '@/components/ConceptImage'
import { ConditionalWrapper } from '@/components/ConditionalWrapper'
import { useDevice } from '@/context/Device'
import { FavouriteSearchOrigin } from '@/lib/api-gluglu-open'
import { ListingCate } from '@/page-commons/listingBySlug'
import { GeoFilter } from '@/types/filter'
import { Filter } from '@/types/graphql-generated-types'
import { isStorageSupported } from '@/utils/isStorageSupported'

import { ContentWrapper } from '../ContentWrapper'

type Props = {
  actualZoneFilterAreas?: GeoFilter[]
  filters?: Filter
  geoSlugs?: string[]
  listing?: ListingCate
  onLoggedIn: VoidFunction
  origin: FavouriteSearchOrigin
  setIsLoadingFavouriteSearch: Dispatch<SetStateAction<boolean>>
  userEmail?: string
}

export const ContentLogin: React.FC<Props> = ({ onLoggedIn, origin }) => {
  const device = useDevice()
  const [returnUrl, setReturnUrl] = useState<string | null>(null)

  useEffect(() => {
    setReturnUrl(window.location.href)
    isStorageSupported(() => sessionStorage) &&
      sessionStorage.setItem(
        'CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN',
        JSON.stringify({
          origin,
          pageUrl: window.location.href,
        })
      )
  }, [])

  return (
    <ConditionalWrapper
      condition={device === 'desktop'}
      wrapper={(children) => (
        <ContentWrapper bgColor="lightBlue" origin={origin}>
          {children}
        </ContentWrapper>
      )}
    >
      <UserAuthentication
        conceptImage={
          device === 'mobile' ? (
            <ConceptImage height={96} name="mail-pidgeon" width={96} />
          ) : (
            <ConceptImage height={120} name="mail" width={120} />
          )
        }
        mainTitle="Login_SaveSearch_BottomSheet_Title"
        returnUrl={returnUrl}
        showCasavoLogo={false}
        touchPoint="FromSaveSearch"
        onLoggedIn={onLoggedIn}
      />
    </ConditionalWrapper>
  )
}
